//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 const FilterCacheManagement=(params:any)=>request({
  url: ApiURL.Query.GetFilterCacheManagement+"/"+params,
  method: RequestType.GET,
 });

 const ListEcommerceTeam=()=>request({
  url: ApiURL.Query.GetListEcommerceTeam,
  method: RequestType.GET,
 });
 const GetUSerClaims=()=>request({
  url: ApiURL.Query.GetUSerClaims,
  method: RequestType.GET,
 });

 const GetRedisData = (params: any): Promise<any> =>
   request({
     url: ApiURL.Query.GetRedisData,
     method: RequestType.GET,
     params: params,
   });

 const GetDefaultDatabase = (): Promise<any> =>
   request({
     url: ApiURL.Query.GetDefaultDatabase,
     method: RequestType.GET,
   });
 
 

const CacheQuery = {
  FilterCacheManagement,
  ListEcommerceTeam,
  GetUSerClaims,
  GetRedisData,
  GetDefaultDatabase
};

export default CacheQuery;
